<article class="job" [class.job--filled]="!model.online && logged" itemscope itemtype="http://schema.org/JobPosting">
  <!-- Raw model.createdDate because `| date` does not seem to work well with SSR -->
  <meta *ngIf="model.createdDate" itemprop="datePosted" [content]="createdDateStr" />

  <meta itemprop="validThrough" [content]="validThroughStr" />

  <header class="job__header">
    <job-status
      *ngIf="(isMobile$ | async) === false"
      class="job__status"
      [date]="model.createdDate"
      [filled]="!model.online && logged"
    ></job-status>

    <meta *ngIf="metaImageUrl" itemprop="image" [content]="metaImageUrl" />

    <ng-container *ngIf="(isMobile$ | async) === false">
      <a
        *ngIf="logged || model.company?.status === 'PUBLIC'; else logo"
        class="job__company-link--logo"
        [routerLink]="[companyPath, model.company.id]"
        aria-hidden="true"
        tabindex="-1"
        appEventTracker
        eventCategory="Job Page"
        eventAction="Click Company Name"
        eventLabel="Logo"
      >
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
    </ng-container>

    <ng-template #logo>
      <company-logo class="job__company-logo" [company]="model.company"></company-logo>
    </ng-template>

    <div class="job__options">
      <job-share-popup
        *ngIf="logged || (!logged && (isMobile$ | async) === false)"
        [job]="model"
        (openShare)="
          trackEvent({
            eventCategory: 'Job Page',
            eventAction: 'Open Share',
            eventLabel: logged ? 'Logged' : 'Unlogged'
          })
        "
        (share)="
          trackEvent({
            eventCategory: 'Job Page',
            eventAction: 'Share ' + $event,
            eventLabel: logged ? 'Logged' : 'Unlogged'
          })
        "
      ></job-share-popup>

      <ng-container *ngIf="logged">
        <job-more-options-popup
          (report)="
            trackEvent({
              eventCategory: 'Job Page',
              eventAction: 'Click Report',
              eventLabel: logged ? 'Logged' : 'Unlogged'
            })
          "
        ></job-more-options-popup>
      </ng-container>
    </div>

    <span class="job__company-name" itemprop="hiringOrganization" itemscope itemtype="http://schema.org/Organization">
      <a
        *ngIf="
          (logged && (model.company?.status === 'PUBLIC' || model.company?.status === 'PRIVE')) ||
            (!logged && model.company?.status === 'PUBLIC');
          else companyName
        "
        class="job__company-link"
        [routerLink]="[companyPath, model.company.id]"
        appEventTracker
        eventCategory="Job Page"
        eventAction="Click Company Name"
        eventLabel="Header"
      >
        <ng-container *ngTemplateOutlet="companyName"></ng-container>
      </a>
    </span>

    <ng-template #companyName>
      <span itemprop="name">{{ model.company.name }}</span>
    </ng-template>

    <h1 class="job__title" itemprop="title">
      {{ model?.title }}
    </h1>

    <job-tags
      *ngIf="
        model?.contract?.titleShort ||
        model?.duration ||
        (model.location && model.location.short) ||
        model?.degree ||
        model?.domain
      "
      class="job__tags"
      [model]="model"
      [addStructuredData]="true"
    ></job-tags>

    <job-skills
      *ngIf="model?.skills?.length > 0 && (isMobile$ | async) === false"
      class="job__skills"
      [class.hide-mobile]="model?.skills?.length > 0"
      [model]="model.skills"
    ></job-skills>
  </header>

  <!-- apply / bookmark -->
  <hr *ngIf="(isMobile$ | async) === false" class="job__separator hide-mobile" />

  <section class="job__actions" appScrollSpy (appScrollSpyScrolledPast)="applyButtonHidden.emit($event)">
    <div class="job__actions-buttons">
      <div class="job__apply">
        <a
          *ngIf="model.online && logged"
          (click)="handleApplyButtonClick()"
          class="job__button btn"
          [routerLink]="applyLink.routerLink"
          [queryParamsHandling]="applyLink.queryParamsHandling"
          [fragment]="applyLink.fragment"
          [target]="applyLink.target"
          rel="noopener"
          appEventTracker
          eventCategory="Job Page"
          eventAction="Apply"
          eventLabel="Top"
          [algoliaTrackingData]="trackingData"
          i18n="@@job.apply.logged"
          >Postuler maintenant</a
        >

        <a
          *ngIf="!logged"
          i18n="@@job.apply.unlogged"
          class="job__button btn"
          [href]="accountSignupUrlJob"
          appEventTracker
          eventCategory="Job Page"
          eventAction="Click See Job"
          eventLabel="Unlogged"
          >Postuler maintenant</a
        >

        <span *ngIf="!model.online && logged" class="job__button job__button--filled btn" i18n>
          Offre pourvue&nbsp;!
        </span>

        <span *ngIf="!model.externalUrl" class="job__quick-apply" i18n>Candidature simplifiée</span>
      </div>

      <job-bookmark
        *ngIf="(isMobile$ | async) === false && !logged"
        class="job__bookmark"
        [class.hide-mobile]="!logged"
        [model]="bookmark"
        (toggle)="toggleBookmark.emit($event)"
        [seamless]="false"
      ></job-bookmark>
    </div>
  </section>

  <section *ngIf="(isMobile$ | async) === true" class="job__actions">
    <job-status
      class="job__status"
      [style.position]="(isMobile$ | async) === true ? 'relative' : 'absolute'"
      [date]="model.createdDate"
      [filled]="!model.online && logged"
    ></job-status>
  </section>

  <job-skills
    *ngIf="model?.skills?.length > 0 && (isMobile$ | async) === true"
    class="job__skills"
    [model]="model.skills"
  ></job-skills>

  <!-- content -->
  <section *ngIf="mission" itemprop="description" class="job__section">
    <h2 class="job__section-header" i18n>Description de l'offre</h2>

    <p [innerHtml]="mission | raw" (appMutationObserver)="secureExternalLinks($event)"></p>
  </section>

  <section class="job__section" *ngIf="model.profile" itemprop="experienceRequirements">
    <h3 class="job__section-header" i18n>Profil recherché</h3>

    <p [innerHtml]="model.profile | raw" (appMutationObserver)="secureExternalLinks($event)"></p>
  </section>

  <div
    *ngIf="
      isBrowser &&
      wizbiiDomain &&
      wizbiiDomain !== 'undefined' &&
      locale === LocaleEnum.fr_FR &&
      (isMobile$ | async) === true
    "
    class="media-pub"
  >
    <wiz-media [attr.domain]="wizbiiDomain" cookiekey="wizbii_tokens" spot="TopBarAdWizbii"></wiz-media>
  </div>

  <section class="job__section" *ngIf="model.descriptionCompany">
    <h3 class="job__section-header" i18n-aria-label aria-label="accéder à la page de l'entreprise" i18n>
      À propos de
      <a
        [routerLink]="[companyPath, model.company.id]"
        appEventTracker
        eventCategory="Job Page"
        eventAction="Click Company Name"
        eventLabel="Bottom"
      >
        {{ model.company.name }}
      </a>
    </h3>

    <p
      class="job__company-description"
      [innerHtml]="descriptionCompany | raw"
      (appMutationObserver)="secureExternalLinks($event)"
    ></p>
  </section>
  <ng-content></ng-content>
</article>

<ul *ngIf="!logged && (isMobile$ | async) === true" class="share">
  <li *ngFor="let item of shareLinks; index as i; trackBy: trackByLabel">
    <a
      class="job-share__link"
      [href]="item.url"
      target="_blank"
      rel="noopener"
      (click)="
        trackEvent({
          eventCategory: 'Job Page',
          eventAction: 'Share ' + $event,
          eventLabel: logged ? 'Logged' : 'Unlogged'
        })
      "
    >
      <app-svg-icon class="job-share__icon" [icon]="item.media.icon" width="2.5em"></app-svg-icon>
    </a>
  </li>
</ul>
